import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  padding: 34px 24px 60px 24px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 24px 24px 0 0;

  .close {
    border: none;
    background: none;

    width: 36px;
    height: 36px;

    position: absolute;

    top: 20px;
    right: 20px;

    svg {
      path {
        stroke: rgb(${({ theme }) => theme.grayscale[100]});
      }
    }
  }

  .title {
    color: rgb(${({ theme }) => theme.grayscale[100]});

    margin-bottom: 4px;

    font-size: 18px;
    font-weight: 700;
    line-height: 120%;

    margin-bottom: 30px;
  }

  .description {
    color: rgb(${({ theme }) => theme.grayscale[100]});

    font-size: 16px;
    font-weight: 600;
    line-height: 120%;

    margin-bottom: 24px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 24px;

    margin-bottom: 24px;

    .text-input {
      padding: 1rem;
      border-radius: 8px;

      background: transparent;

      width: 100%;

      font-size: 16px;

      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
      font-weight: 600;

      border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

      &::placeholder {
        font-weight: 400;
        color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
      }
    }

    .save {
      color: ${({ theme }) => `rgb(${theme.background.low})`};

      background-color: rgb(${({ theme }) => theme.primary.base});
      border: none;

      height: 52px;

      border-radius: 4px;

      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 140%;

      transition: opacity 0.3s ease;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &[data-loading='true'] {
        cursor: progress;
      }

      .loader {
        width: 32px;
        height: 32px;
      }
    }
  }

  .current-name {
    color: rgb(${({ theme }) => theme.grayscale[200]});

    font-size: 16px;
    font-weight: 600;
    line-height: 120%;

    b {
      color: rgb(${({ theme }) => theme.grayscale[100]});
    }
  }

  @media only screen and (min-width: 800px) {
    border-radius: 6px;

    padding: 30px 30px 40px 38px;

    min-width: 600px;
  }

  @media only screen and (min-width: 1000px) {
    min-width: 690px;

    margin: 0 auto;

    .title {
      font-size: 24px;

      margin-bottom: 36px;
    }

    .input-group {
      flex-direction: row;
      gap: 24px;

      .save {
        flex: 1 0 222px;
      }
    }
  }
`
